import { DeploymentInitiateRequest, DeploymentResponse } from '@/types/service/deployment';

import { baseProtectedApi } from '@/store/baseApi';

export const deploymentApi = baseProtectedApi.injectEndpoints({
  endpoints: (builder) => ({
    initiateDeployment: builder.mutation<DeploymentResponse, DeploymentInitiateRequest>({
      query: (data) => ({
        url: '/v1/protected/deployment/initiate',
        method: 'POST',
        data: data,
      }),
    }),
    deploymentAction: builder.mutation<
      DeploymentResponse,
      { action: 'approve' | 'decline'; deployment_id: number }
    >({
      query: ({ action, deployment_id }) => ({
        url: `/v1/protected/deployment/action?action=${action}&deployment_id=${deployment_id}`,
        method: 'POST',
      }),
    }),
  }),
});

export const { useInitiateDeploymentMutation, useDeploymentActionMutation } = deploymentApi;
